<template>  
  <div id="App"> 
    <b-modal id="bv-modal-error" hide-footer>
      <template v-slot:modal-title>Datos no validos</template>
      <div class="alertError">
        {{this.$store.state.modalBody}}
      </div>
    </b-modal>       
    <TopLayout/>  
    <div class="contentApp">  
      <router-view/>
    </div>
    <FooterLayout/>    
  </div>
</template>

<script>
  import TopLayout from './views/layout/Top'
  import FooterLayout from './views/layout/Footer'
  export default {
    components: {TopLayout, FooterLayout}    
  }
</script>

<style>  
  @import '../src/assets/css/font-awesome.min.css';
  @import '../src/assets/css/themify-icons.css';
  @import '../src/assets/css/general.css';
</style>